import React from 'react';
import logo from '../images/stitchivitylogo-large.svg'

const Header = () => {
  return (
    <header className="header_section long_section px-0">
      <nav className="navbar navbar-expand-lg custom_nav-container">
        <a className="navbar-brand" href="/">
            <img src={logo} alt="Stitchivity Logo" width="250" height="100"/>
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className=""> </span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="d-flex mx-auto flex-column flex-lg-row align-items-center">
            <ul className="navbar-nav">
              <li className="nav-item active">
                <a className="nav-link" href="/">Home <span className="sr-only">(current)</span></a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/"> About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/">Pattern Builder</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/">Blog</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/">Contact Us</a>
              </li>
            </ul>
          </div>
          <div className="quote_btn-container">
            <a href="">
              <span>
                Login
              </span>
              <i className="fa fa-user" aria-hidden="true"></i>
            </a>
            <form className="form-inline">
              <button className="btn my-2 my-sm-0 nav_search-btn" type="submit">
                <i className="fa fa-search" aria-hidden="true"></i>
              </button>
            </form>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;